const NAME = "CONCEPT_STRUCTURE";

export default NAME;
